import moment from 'moment-timezone';

export default function (data) {
	let shopsData = [];

	const time = new moment().tz('Europe/Amsterdam').format('X');
	const env = ['uat', 'dev'].includes(process.env.ENV.toLowerCase()) ? 'uat' : 'live';

	if (data.items.length && data.items[0].fields.shops) {
		data.items[0].fields.shops
			.filter(shop => !!shop.fields && shop.fields?.environment.toLowerCase() === env) // Filter out shops in 'draft' state
			.forEach(shop => {
				let shopData = {};
				let shopFields = shop.fields;
				// Merge fields from shopTheme with main shop fields
				if (shop.fields.hasOwnProperty('shopTheme')) {
					delete shop.fields.shopTheme.fields.title;
					shopFields = {
						...shop.fields,
						...shop.fields.shopTheme.fields
					};
				}

				if (shop.fields.hasOwnProperty('shopSettings')) {
					// Set default for showing of min/max ticket values
					if (!shop.fields.shopSettings.fields?.hideTicketMinMax)
						shop.fields.shopSettings.fields.hideTicketMinMax = false;

					// Set default for the event time format for cards
					if (!shop.fields.shopSettings.fields.eventDatetimeFormat) {
						shop.fields.shopSettings.fields.eventDatetimeFormat = [
							'Day of the Week - Short',
							'Day of the Month',
							'Month - Long',
							'Year',
							'Time'
						];
					}

					shopFields = {
						...shopFields,
						...shop.fields.shopSettings.fields
					};

					delete shop.fields.shopSettings;
				}

				shopData = {
					...shopFields,
					festivalData: {
						title: shopFields.title,
						titleFull: shopFields.titleFull ? shopFields.titleFull : shopFields.title,
						dateStart: shopFields.dateStart,
						dateEnd: shopFields.dateEnd ? shopFields.dateEnd : shopFields.saleEndDate,
						location: shopFields.location,
						logo: (shopFields.logo && shopFields.logo.fields.file.url) || '',
						heroImage:
							(shopFields.heroImage &&
								`${shopFields.heroImage.fields.file.url}?fm=jpg&fl=progressive&w=1440&q=90`) ||
							''
					},
					salesOptions: (shopFields.salesOptions && shopFields.salesOptions.map(item => item.fields)) || [],
					upsellProducts:
						(shopFields.upsellProducts && shopFields.upsellProducts.map(item => item.fields)) || [],
					upsellProductsSummary:
						(shopFields.upsellProductsSummary &&
							shopFields.upsellProductsSummary.map(item => item.fields)) ||
						[]
				};

				const dateStart = new moment(shopFields.saleDate).format('X');
				const dateEnd = new moment(shopFields.saleEndDate).format('X');
				const isLive = time >= dateStart && time <= dateEnd;

				//filter for externalshop the saleDate is not requierd for these. This hack al make the externshop card visible
				if ((!shopData.products || shopData?.products?.length === 0) && !shopFields.saleDate) {
					shopData.saleActive = true;
				} else {
					shopData.saleActive = isLive;
				}

				if (!shopData.products && shopData.dateText != undefined) {
					shopData.isComingSoonItem = true;
				} else {
					shopData.isComingSoonItem = false;
				}

				if (!shopData.isComingSoonItem) {
					if (!shopData.productsInSalesOptions) {
						shopData.products = (shopFields.products && shopFields.products.map(item => item.fields)) || [];
					} else {
						if (shopData.salesOptions && shopData.salesOptions.length > 0) {
							shopData.products = [];

							for (let i = 0; i < shopData.salesOptions.length; i++) {
								const option = shopData.salesOptions[i];
								if (option.products) {
									option.products.forEach(item => {
										shopData.products.push(item.fields);
									});
								}
								if (option.salesOptionCategory && option.salesOptionCategory.length > 0) {
									for (let j = 0; j < option.salesOptionCategory.length; j++) {
										const category = option.salesOptionCategory[j];
										const products = category.fields.products.map(item => {
											const product = { ...item.fields };
											product.salesOptionCategory = category.fields.slug;
											product.salesOptionCategoryTitle = category.fields.title;
											product.salesOption = option.slug;
											return product;
										});

										shopData.products.push(...products);
									}
								}
							}
						}
					}
				}

				if (shopData.merchandiseHeader) {
					shopData.merchandiseHero = {
						desktop:
							`${shopData.merchandiseHeader.fields.desktopImage.fields.file.url}?fm=jpg&fl=progressive&w=1440&q=90` ||
							null,
						mobile:
							`${shopData.merchandiseHeader.fields.mobileImage.fields.file.url}?fm=jpg&fl=progressive&w=720&q=90` ||
							null
					};
				}
				shopsData.push(shopData); // Add to array of shops
			});
	}

	return shopsData;
}
